import React from 'react';
import EnvInfoRow from './EnvInfoRow';

function EnvInfoTable({ routingInfo }) {

  return (
    <table className="table table-light table-striped">
        <thead>
            <tr className='table-primary'>
                <th>Environment</th>
                <th>Routing code</th>
                <th>Demo / Live</th>
                <th>SysKey</th>
                <th>ApiKey</th>
            </tr>
        </thead>
        <tbody>
            {routingInfo && !routingInfo.infoByEnv &&
                <EnvInfoRow 
                env={'Current'} 
                routingCode={routingInfo.routingCode} 
                isDemo={routingInfo.isDemo} 
                sysKey={routingInfo.sysKey}
                apiKey={routingInfo.apiKey} />
            }
            {routingInfo && routingInfo.infoByEnv &&
                Object.keys(routingInfo.infoByEnv).map(env => (
                    <EnvInfoRow 
                    env={env} 
                    routingCode={routingInfo.infoByEnv[env].routingCode} 
                    isDemo={routingInfo.infoByEnv[env].isDemo}
                    sysKey={routingInfo.infoByEnv[env].sysKey}
                    apiKey={routingInfo.infoByEnv[env].apiKey} 
                    currentEnvName={routingInfo.currentEnvName}
                    key={env}/>
                ))                
            }
        </tbody>
    </table>
  );
}

export default EnvInfoTable;